// src/app/redux/reducers/skillEvaluationReducer.js

import {
    FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST, FETCH_SKILL_EVALS_BY_CAMPAGNE_SUCCESS, FETCH_SKILL_EVALS_BY_CAMPAGNE_FAIL,
    FETCH_SKILL_EVALS_BY_USER_REQUEST, FETCH_SKILL_EVALS_BY_USER_SUCCESS, FETCH_SKILL_EVALS_BY_USER_FAIL,
    CREATE_SKILL_EVAL_REQUEST, CREATE_SKILL_EVAL_SUCCESS, CREATE_SKILL_EVAL_FAIL,
    UPDATE_SKILL_EVAL_REQUEST, UPDATE_SKILL_EVAL_SUCCESS, UPDATE_SKILL_EVAL_FAIL,
    DELETE_SKILL_EVAL_REQUEST, DELETE_SKILL_EVAL_SUCCESS, DELETE_SKILL_EVAL_FAIL,
    SET_SKILL_EVAL_LOADING, CLEAR_SKILL_EVAL_ERROR,
    SUBMIT_AUTO_EVAL_REQUEST, SUBMIT_AUTO_EVAL_SUCCESS, SUBMIT_AUTO_EVAL_FAIL,
    SKILL_MANAGER_DECISION_REQUEST, SKILL_MANAGER_DECISION_SUCCESS, SKILL_MANAGER_DECISION_FAIL,
    SKILL_RF_DECISION_REQUEST, SKILL_RF_DECISION_SUCCESS, SKILL_RF_DECISION_FAIL,
    FETCH_SKILL_MANAGER_INBOX_REQUEST, FETCH_SKILL_MANAGER_INBOX_SUCCESS, FETCH_SKILL_MANAGER_INBOX_FAIL,
    FETCH_SKILL_RF_INBOX_REQUEST, FETCH_SKILL_RF_INBOX_SUCCESS, FETCH_SKILL_RF_INBOX_FAIL,
} from "../actions/skillEvaluationActions";

const initialState = {
    skillEvaluations: [],
    inboxManager: [],
    inboxRf: [],
    loading: false,
    error: null,
};

export default function skillEvaluationReducer(state = initialState, action) {
    switch (action.type) {

        case SET_SKILL_EVAL_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_SKILL_EVAL_ERROR:
            return { ...state, error: null };

        case FETCH_SKILL_EVALS_BY_CAMPAGNE_REQUEST:
        case FETCH_SKILL_EVALS_BY_USER_REQUEST:
        case CREATE_SKILL_EVAL_REQUEST:
        case UPDATE_SKILL_EVAL_REQUEST:
        case DELETE_SKILL_EVAL_REQUEST:
        case SUBMIT_AUTO_EVAL_REQUEST:
        case SKILL_MANAGER_DECISION_REQUEST:
        case SKILL_RF_DECISION_REQUEST:
        case FETCH_SKILL_MANAGER_INBOX_REQUEST:
        case FETCH_SKILL_RF_INBOX_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_SKILL_EVALS_BY_CAMPAGNE_SUCCESS:
        case FETCH_SKILL_EVALS_BY_USER_SUCCESS:
            return { ...state, loading: false, skillEvaluations: action.payload || [] };

        case CREATE_SKILL_EVAL_SUCCESS:
            return { ...state, loading: false, skillEvaluations: [...state.skillEvaluations, action.payload] };

        case UPDATE_SKILL_EVAL_SUCCESS:
        case SUBMIT_AUTO_EVAL_SUCCESS:
            return {
                ...state,
                loading: false,
                skillEvaluations: state.skillEvaluations.map((e) =>
                    e.id === action.payload.id ? action.payload : e
                ),
            };

        case SKILL_MANAGER_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                inboxManager: state.inboxManager.filter((e) => e.id !== action.payload.id),
                skillEvaluations: state.skillEvaluations.map((e) =>
                    e.id === action.payload.id ? action.payload : e
                ),
            };

        case SKILL_RF_DECISION_SUCCESS:
            return {
                ...state,
                loading: false,
                inboxRf: state.inboxRf.filter((e) => e.id !== action.payload.id),
                skillEvaluations: state.skillEvaluations.map((e) =>
                    e.id === action.payload.id ? action.payload : e
                ),
            };

        case FETCH_SKILL_MANAGER_INBOX_SUCCESS:
            return { ...state, loading: false, inboxManager: action.payload || [] };

        case FETCH_SKILL_RF_INBOX_SUCCESS:
            return { ...state, loading: false, inboxRf: action.payload || [] };

        case DELETE_SKILL_EVAL_SUCCESS:
            return {
                ...state,
                loading: false,
                skillEvaluations: state.skillEvaluations.filter((e) => e.id !== action.payload.id),
            };

        case FETCH_SKILL_EVALS_BY_CAMPAGNE_FAIL:
        case FETCH_SKILL_EVALS_BY_USER_FAIL:
        case CREATE_SKILL_EVAL_FAIL:
        case UPDATE_SKILL_EVAL_FAIL:
        case DELETE_SKILL_EVAL_FAIL:
        case SUBMIT_AUTO_EVAL_FAIL:
        case SKILL_MANAGER_DECISION_FAIL:
        case SKILL_RF_DECISION_FAIL:
        case FETCH_SKILL_MANAGER_INBOX_FAIL:
        case FETCH_SKILL_RF_INBOX_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}